var map = {
	"./coinbaseWalletIcon.svg": 52654,
	"./ethereum-logo.png": 78780,
	"./fortmaticIcon.png": 53911,
	"./menu.svg": 28647,
	"./metamask.png": 58843,
	"./portisIcon.png": 51307,
	"./walletConnectIcon.svg": 69854,
	"./x.svg": 91275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;